import { useTranslation } from "react-i18next";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { SIMPLDialog } from "../../components/commons/dialog/SimplDialog";
import { ModalDetailBody } from "../../components/commons/modal/ModalDetailBody";
import { OutputTemplateItem } from "~/models/outputTemplate/OutputTemplate";

interface DetailViewOutputTemplateProps {
  item: OutputTemplateItem;
  onClose: () => void;
}

const labelClass = "font-semibold max-w-[300px]";

export const DetailViewOutputTemplate = ({
  item,
  onClose,
}: DetailViewOutputTemplateProps) => {
  const { t } = useTranslation();

  return (
    <SIMPLDialog
      onCloseModal={onClose}
      title={t("OutputTemplateDetailTitle")}
    >
      <ModalDetailBody testId="output-template-detail-view">
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("Name")}</div>
            <div>{item.name}</div>
          </div>
        </div>

        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("Status")}</div>
            <div
              className={`inline-flex items-center justify-center min-h-[32px] min-w-[64px] rounded-full opacity-100 px-3 py-[var(--spacing-2xs)] gap-2 font-bold text-black ${
                item.active
                  ? "bg-[var(--color-primary-lightest,#F9E4F5)]"
                  : "bg-gray-200"
              }`}
            >
              <span className="flex items-center justify-center w-5 h-5 rounded-full">
                <CheckCircleOutlineOutlinedIcon fontSize="small" />
              </span>
              {item.active ? t("Active") : t("Inactive")}
            </div>
          </div>
          <div className="flex-1 ml-3">
            <div className={labelClass}>{t("DateAdded")}</div>
            <div>
              {item.creationDate
                ? new Date(item.creationDate).toLocaleDateString()
                : "—"}
            </div>
          </div>
        </div>

        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("CloudProvider")}</div>
            <div>{item.cloudProvider?.cloudProviderName ?? "—"}</div>
          </div>
        </div>

        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("ScriptType")}</div>
            <div>{item.scriptType?.name ?? "—"}</div>
          </div>
        </div>
      </ModalDetailBody>
    </SIMPLDialog>
  );
};
